<template>
    <!--弹窗-->
    <el-dialog
        width="650px"
        title="基础配置数据"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" label-width="230px">
            <el-form-item label="美国快递运费价格/kg：">
                <el-input-number
                    v-model="formData.us_kd_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国快递运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="美国空派运费价格/kg：">
                <el-input-number
                    v-model="formData.us_kp_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国空派运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="美国美森运费价格/kg：">
                <el-input-number
                    v-model="formData.us_ms_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国美森运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="美国普船运费价格/kg：">
                <el-input-number
                    v-model="formData.us_pc_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国普船运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="英国快递运费价格/kg：">
                <el-input-number
                    v-model="formData.uk_kd_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国快递运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="英国空派运费价格/kg：">
                <el-input-number
                    v-model="formData.uk_kp_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国空派运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="英国卡航运费价格/kg：">
                <el-input-number
                    v-model="formData.uk_kh_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国卡航运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="英国海运运费价格/kg：">
                <el-input-number
                    v-model="formData.uk_hy_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国海运运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国快递运费价格/kg：">
                <el-input-number
                    v-model="formData.de_kd_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国快递运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国空派运费价格/kg：">
                <el-input-number
                    v-model="formData.de_kp_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国空派运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国卡航运费价格/kg：">
                <el-input-number
                    v-model="formData.de_kh_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国卡航运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国铁路运费价格/kg：">
                <el-input-number
                    v-model="formData.de_tl_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国铁路运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="国内头程运费价格/kg">
                <el-input-number
                    v-model="formData.domestic_head_price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入国内头程运费价格/kg"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="美国汇率：">
                <el-input-number
                    v-model="formData.us_exchange_rate"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国汇率"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="英国汇率：">
                <el-input-number
                    v-model="formData.uk_exchange_rate"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国汇率"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国汇率：">
                <el-input-number
                    v-model="formData.de_exchange_rate"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国汇率"
                >
                </el-input-number>
            </el-form-item>


            <el-form-item label="美国利润对比值：">
                <el-input-number
                    v-model="formData.us_compare_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入美国利润对比值"
                >
                </el-input-number>
            </el-form-item>

            <el-form-item label="英国利润对比值：">
                <el-input-number
                    v-model="formData.uk_compare_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入英国利润对比值"
                >
                </el-input-number>
            </el-form-item>
            <el-form-item label="德国利润对比值：">
                <el-input-number
                    v-model="formData.de_compare_profit"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入德国利润对比值"
                >
                </el-input-number>
            </el-form-item>
            <!--            <el-form-item label="产品价格：" prop="product_price">-->
            <!--                <el-input-->
            <!--                    v-model="formData.product_price"-->
            <!--                    style="width: 300px;margin-right:20px;"-->
            <!--                    size="mini"-->
            <!--                    placeholder="请输入产品价格"-->
            <!--                >-->
            <!--                    <template slot="prepend">$</template>-->
            <!--                </el-input>-->
            <!--            </el-form-item>-->
        </el-form>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >取 消
            </el-button
            >
            <el-button
                style="float:right"
                size="mini"
                type="primary"
                @click="submitForm()"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        components: {},
        data() {
            return {
                loading: false,
                formData: {
                    us_kd_price: 0,
                    us_kp_price: 0,
                    us_ms_price: 0,
                    us_pc_price: 0,
                    uk_kd_price: 0,
                    uk_kp_price: 0,
                    uk_kh_price: 0,
                    uk_hy_price: 0,
                    de_kd_price: 0,
                    de_kp_price: 0,
                    de_kh_price: 0,
                    de_tl_price: 0,
                    domestic_head_price: 0,
                    us_exchange_rate: 0,
                    uk_exchange_rate: 0,
                    de_exchange_rate: 0,
                }
            }
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.getControlMessage()
        },
        methods: {
            getControlMessage() {
                this.loading=true
                api.variety_cost_control_analysis_get_cost_control_message().then(res => {
                    if (res.code === 0) {
                        this.$set(this, 'formData', res.data)
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            // 保存信息
            submitForm() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        let formData = JSON.parse(JSON.stringify(this.formData))
                        this.loading = true
                        api.variety_cost_control_analysis_update_cost_control_message(formData)
                            .then(res => {
                                this.loading = false
                                if (res.code === 0) {
                                    this.$message({
                                        message: '修改成功',
                                        type: 'success'
                                    })
                                    this.handleClose()
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.message
                                    })
                                }
                            })
                            .catch(() => {
                                this.loading = false
                                this.$message({
                                    type: 'error',
                                    message: '网络出现问题，请刷新页面！'
                                })
                            })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.formData =  {
                    us_kd_price: 0,
                    us_kp_price: 0,
                    us_ms_price: 0,
                    us_pc_price: 0,
                    uk_kd_price: 0,
                    uk_kp_price: 0,
                    uk_kh_price: 0,
                    uk_hy_price: 0,
                    de_kd_price: 0,
                    de_kp_price: 0,
                    de_kh_price: 0,
                    de_tl_price: 0,
                    domestic_head_price: 0,
                    us_exchange_rate: 0,
                    uk_exchange_rate: 0,
                    de_exchange_rate: 0,
                }
                this.loading = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
